/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc
 */

export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const BooleanFieldValueDiscriminant = 'boolean';
export const BooleanFieldValueDiscriminantKey = '@type';
export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const DoubleFieldValueDiscriminant = 'double';
export const DoubleFieldValueDiscriminantKey = '@type';
export const FieldValueDiscriminantKey = '@type';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const FloatFieldValueDiscriminant = 'float';
export const FloatFieldValueDiscriminantKey = '@type';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const IntFieldValueDiscriminant = 'integer';
export const IntFieldValueDiscriminantKey = '@type';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const ListFieldValueDiscriminant = 'list';
export const ListFieldValueDiscriminantKey = '@type';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const LongFieldValueDiscriminant = 'long';
export const LongFieldValueDiscriminantKey = '@type';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const MapFieldValueDiscriminant = 'map';
export const MapFieldValueDiscriminantKey = '@type';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const NullFieldValueDiscriminant = 'null';
export const NullFieldValueDiscriminantKey = '@type';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const StringFieldValueDiscriminant = 'string';
export const StringFieldValueDiscriminantKey = '@type';
export const BrightnessOffsetModifierTypename = 'com.hubspot.content.model.customwidgets.inherited.BrightnessOffsetModifier';
export const BrightnessOffsetModifierDiscriminant = 'BRIGHTNESS_OFFSET';
export const BrightnessOffsetModifierDiscriminantKey = 'modifier_type';
export const ModifierDiscriminantKey = 'modifier_type';
export const ShadeModifierTypename = 'com.hubspot.content.model.customwidgets.inherited.ShadeModifier';
export const ShadeModifierDiscriminant = 'SHADE';
export const ShadeModifierDiscriminantKey = 'modifier_type';
export const ShadeOffsetModifierTypename = 'com.hubspot.content.model.customwidgets.inherited.ShadeOffsetModifier';
export const ShadeOffsetModifierDiscriminant = 'SHADE_OFFSET';
export const ShadeOffsetModifierDiscriminantKey = 'modifier_type';
export const BadRequestErrorTypename = 'com.hubspot.global.styles.models.rpc.BadRequestError';
export const BadRequestErrorDiscriminant = 'BadRequestError';
export const BadRequestErrorDiscriminantKey = '@type';
export const GlobalStylesErrorDiscriminantKey = '@type';
export const NotFoundErrorTypename = 'com.hubspot.global.styles.models.rpc.NotFoundError';
export const NotFoundErrorDiscriminant = 'NotFoundError';
export const NotFoundErrorDiscriminantKey = '@type';
export const ValidationErrorTypename = 'com.hubspot.global.styles.models.rpc.ValidationError';
export const ValidationErrorDiscriminant = 'ValidationError';
export const ValidationErrorDiscriminantKey = '@type';
export const getRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'get',
  auth: 'app',
  fingerprint: 'TT2Ful4GP6zoUqUgX3Yq2M9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getForActiveThemeRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'getForActiveTheme',
  auth: 'app',
  fingerprint: 'TT2Ful4GP6zoUqUgX3Yq2M9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'create',
  auth: 'app',
  fingerprint: 'cue2oB9IJMToUqUgX3Yq2M9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'update',
  auth: 'app',
  fingerprint: 'yvuI8HykB4foUqUgX3Yq2M9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const archiveRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'archive',
  auth: 'app',
  fingerprint: 'IBKJIWwCMv0XXRyap94UH89ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const unarchiveRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'unarchive',
  auth: 'app',
  fingerprint: 'IBKJIWwCMv3oUqUgX3Yq2M9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const hasBufferedChangesRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'hasBufferedChanges',
  auth: 'app',
  fingerprint: 'IBKJIWwCMv1_c7OzYhY5UM9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const hasBufferedChangesForActiveThemeRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'hasBufferedChangesForActiveTheme',
  auth: 'app',
  fingerprint: 'k-8GcWPsH7Z_c7OzYhY5UM9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBufferRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'getBuffer',
  auth: 'app',
  fingerprint: 'IBKJIWwCMv3oUqUgX3Yq2M9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPortalBufferRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'getPortalBuffer',
  auth: 'app',
  fingerprint: 'k-8GcWPsH7boUqUgX3Yq2M9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPortalBufferForActiveThemeRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'getPortalBufferForActiveTheme',
  auth: 'app',
  fingerprint: 'k-8GcWPsH7boUqUgX3Yq2M9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const upsertBufferRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'upsertBuffer',
  auth: 'app',
  fingerprint: 'xip7zaFip1LoUqUgX3Yq2M9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const pushBufferLiveRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'pushBufferLive',
  auth: 'app',
  fingerprint: 'IBKJIWwCMv3oUqUgX3Yq2M9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const pushBufferLiveForActiveThemeRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'pushBufferLiveForActiveTheme',
  auth: 'app',
  fingerprint: '2MD-dIpI4qLoUqUgX3Yq2M9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMergedGlobalStylesRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'getMergedGlobalStyles',
  auth: 'app',
  fingerprint: '9jWzWHXIbzXoUqUgX3Yq2M9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getByThemeRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'getByTheme',
  auth: 'app',
  fingerprint: 'J_s1dwJB96roUqUgX3Yq2M9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBufferByThemeRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'getBufferByTheme',
  auth: 'app',
  fingerprint: 'J_s1dwJB96roUqUgX3Yq2M9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listByPortalRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'listByPortal',
  auth: 'app',
  fingerprint: 'hII9OXR0D1edShIUW9xi8M9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createForThemeRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'createForTheme',
  auth: 'app',
  fingerprint: 'dD6FqjvCec_oUqUgX3Yq2M9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};